import React, { useState } from "react";
import { Link as ReactLink } from 'react-router-dom';
import { Table, Tbody, Tr, TableContainer, Td, Link, Box, Stack, InputGroup, InputRightElement, Input, Divider, AbsoluteCenter, Text } from "@chakra-ui/react";
import { ForecastRegionList } from "./ForecastRegionList";
import { SearchIcon } from "../../components/stations/assets/search-icon";

export const ForecastIndex = () => {
    const [searchTerm, setSearchTerm] = useState('');

    // Handles the search input change
    const handleSearchInputChange = (event) => {
        setSearchTerm(event.target.value);
    };

    // Filters stations based on the search term
    const filteredRegions = ForecastRegionList.filter(station => station.name.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <Box>
            <Box paddingLeft={5} paddingRight={5}>
                <Text fontSize={'20px'} fontWeight={'bold'} marginTop={5}>Forecast Regions</Text>
                <Text color={'gray.500'} marginBottom={5}>Regions ({ForecastRegionList.length})</Text>
                <Stack spacing={4}>
                    <InputGroup>
                        <InputRightElement pointerEvents='none' backgroundColor={'gray.100'} borderRightRadius={8} border={'1px rgb(203, 213, 224) solid'}>
                            <SearchIcon color='gray.300' />
                        </InputRightElement>
                        <Input type='search' placeholder='Search Stations...' value={searchTerm} onChange={handleSearchInputChange} />
                    </InputGroup>
                </Stack>
                <Box position='relative' paddingTop='10' paddingBottom='10'>
                    <Divider />
                    <AbsoluteCenter bg='white' px='4' textColor={'gray.400'} marginBottom={20}>All Regions</AbsoluteCenter>
                </Box>
            </Box>
            <TableContainer>
                <Table variant="simple">
                    <Tbody>
                        {filteredRegions.map((region, idx) => (
                            <Tr key={region.name}>
                                <Td style={{ textWrap: 'wrap' }}>
                                    {idx === 0 ? (
                                        <Link textColor={'teal.700'} as={ReactLink} to={`/stations/`}>
                                            {region.name}
                                        </Link>
                                    ) : (
                                        <Text textColor={'gray.500'}>{region.name}</Text>
                                    )}
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
    );
};
